import { call, put, takeLatest } from 'redux-saga/effects';

import { actions } from '@search/store/actions/requests';
import { updateProgram } from '@search/store/actions/programs';
import { updateResult } from '@search/store/actions/results';
import API from '@api';

function* fetchProgramDetails(action) {
  try {
    const program = yield call(
      API.getProgramDetailsSimple.bind(API),
      action.pid,
    );
    delete program.service_id;
    delete program.uuid;

    let targetAction = null;
    if (action.progType == 'result') {
      targetAction = updateResult;
    }

    if (action.progType == 'program') {
      targetAction = updateProgram;
    }

    yield put(targetAction(action.id, program));
  } catch (e) {
    console.error(e);
  }
}

function* programDetailsSaga() {
  yield takeLatest(actions.details, fetchProgramDetails);
}

export default programDetailsSaga;
